import { defineMessages } from 'react-intl';

const messages = defineMessages({
  prevWeek: {
    id: 'repvisits.search.prevWeek',
    defaultMessage: 'Previous week',
  },
  nextWeek: {
    id: 'repvisits.search.nextWeek',
    defaultMessage: 'Next week',
  },
  searchForPlaceholder: {
    id: 'repvisits.search.searchForPlaceholder',
    defaultMessage: 'Search for a school...',
  },
  searchByChoice: {
    id: 'repvisits.search.searchByChoice',
    defaultMessage: 'Search by',
  },
  repVisitsSubscriptionLimited: {
    id: 'repvisits.subscription.limited',
    defaultMessage: 'You currently have limited access to RepVisits.',
  },
  repVisitsSubscriptionUpgrade: {
    id: 'repvisits.subscription.upgrade',
    defaultMessage: 'Upgrade today to view multiple school schedules at once, map your results, and use advanced search filters.',
  },
  repVisitsYourScheduleUpgrade: {
    id: 'repvisits.schedule.upgrade',
    defaultMessage: 'A summary of your upcoming appointments will show here when you upgrade',
  },
  searchValidation: {
    id: 'repvisits.search.searchValidation',
    defaultMessage: 'Please try a search term of at least 2 characters',
  },
  completeList: {
    id: 'repvisits.search.completeList',
    defaultMessage: 'Want a complete list?',
  },
  allHighSchoolLink: {
    id: 'repvisits.search.allHighSchoolLink',
    defaultMessage: 'See all high schools outside of the U.S.',
  },
});

export default messages;
